/* eslint-disable new-cap */
import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';
import { FETCH_USER_SEARCHES, FETCH_USER_SEARCHES_RESOLVED } from 'Store/constants';
import createReducer from 'Store/utils/createReducer';

export const initialState = {
  data: {
    bookings: [],
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
};

export default createReducer(initialState, {
  [FETCH_USER_SEARCHES](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_USER_SEARCHES_RESOLVED](state, action) {
    const fetchedTripsList = get(action, 'payload.bookings', []);
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      data: {
        bookings: fetchedTripsList,
      },
    };
  },
  [reject(FETCH_USER_SEARCHES)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: false,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
});
